var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5846 9.79875C15.6225 9.917 15.7058 10.0154 15.8162 10.0723C15.9265 10.1293 16.055 10.1401 16.1733 10.1025C16.4171 10.0238 16.5558 9.76125 16.4771 9.51375L16.4767 9.51263C16.4433 9.4125 14.5649 3.75 8.99919 3.75C3.43456 3.75 1.55581 9.4125 1.52281 9.513L1.52244 9.51375C1.44369 9.76125 1.57869 10.0238 1.82619 10.1025C2.07369 10.1813 2.33619 10.0462 2.41494 9.79875C2.48244 9.58875 4.10619 4.6875 8.99994 4.6875C13.8937 4.6875 15.5171 9.58875 15.5846 9.79875ZM8.99956 13.5C9.89467 13.5 10.7531 13.1444 11.386 12.5115C12.019 11.8785 12.3746 11.0201 12.3746 10.125C12.3746 9.22989 12.019 8.37145 11.386 7.73851C10.7531 7.10558 9.89467 6.75 8.99956 6.75C8.10446 6.75 7.24601 7.10558 6.61308 7.73851C5.98014 8.37145 5.62456 9.22989 5.62456 10.125C5.62456 11.0201 5.98014 11.8785 6.61308 12.5115C7.24601 13.1444 8.10446 13.5 8.99956 13.5Z",
    fill: "#F6F6F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.f3fb71a011c4accee52c17737ea37e5c.svg";
export { ForwardRef as ReactComponent };